// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__iP3BK","Name":"Logo_Name__bnpRu","isCollapsed":"Logo_isCollapsed__doq0f","EggyTrademark":"Logo_EggyTrademark__uGAA-"};